<span dropdown>
    <a href class="btn-lang" id="basic-link" dropdownToggle (click)="(false)" aria-controls="basic-link-dropdown">
      <span class="text-uppercase"><i class="material-icons icon">language</i> {{selectedLanguage}}</span>
    </a>
    <ul id="basic-link-dropdown" *dropdownMenu class="btn-lang-dropdown dropdown-menu" role="menu" aria-labelledby="basic-link">
      <li class="dropdown-item " *ngFor="let language of languages">
        <a [routerLink]="null" (click)="setLanguage(language.code)">{{language.name}}</a>
      </li>
    </ul>
  </span>